import {createContext, useContext, useMemo} from 'react';
import {COMPANY_HEADER} from '../../state/services/companyHeader';

/**
 * The company the open KYC window is for, as `{id, name}`, or `null` outside the window.
 *
 * KYCModal pins it when the window opens and provides it here. Every banking call the wizard makes
 * sends it as an explicit company header, so the call reaches that company even if the selected
 * company moves while the form is open. Without the pin the header comes from localStorage at send
 * time, and a legal person was once created against the wrong company that way.
 */
export const KYCCompanyContext = createContext(null);

export const useKYCCompany = () => useContext(KYCCompanyContext);

/**
 * Headers to pass to a banking action from inside the KYC window. `undefined` when there is no
 * pinned company, which leaves the interceptor to apply the stored selection as before.
 */
export const useKYCCompanyHeaders = () => {
  const company = useKYCCompany();
  const companyId = company?.id;
  return useMemo(() => companyId ? {[COMPANY_HEADER]: companyId} : undefined, [companyId]);
};
